export default {
  label: {
    id: 'resolution_flow_return_confirmation_page_cta_go_to_select_your_orderline',
    defaultMessage: 'Get more help',
  },
}
